import React, { useEffect, useState } from "react";
import { Modal, ModalBody, Button } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import oopsImage from "../assets/img/Oops.png";

const ErrorPage = ({
  error = null,
  errorInfo = null,
  onReset = null,
  isRuntimeError = false,
  statusCode = null,
  errorMessage = null,
  show = true,
  onHide = null
}) => {
  const [showModal, setShowModal] = useState(show);

  useEffect(() => {
    setShowModal(show);
  }, [show]);

  const handleClose = () => {
    if (statusCode === 401) return;
    onHide?.();
    setShowModal(false);
  };

  // Only show modal for 500 internal server errors
  if (statusCode !== 500) {
    return null;
  }

  return (
    <Modal 
      show={showModal} 
      onHide={handleClose} 
      centered 
      size="md" 
      backdrop="static"
      className="error-page-modal"
      style={{ zIndex: 99999 }}
      enforceFocus={false}
      restoreFocus={false}
    >
      <ModalBody 
        style={{ 
          textAlign: "center", 
          border: "none",
          borderRadius: "12px",
          padding: "1rem"
        }}
      >
        <div style={{
          backgroundColor: "white",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "1.5rem",
          width: "100%"
        }}>
          {/* Oops Image - Always shown since modal only appears for 500 errors */}
          <img 
            src={oopsImage} 
            alt="Oops" 
            style={{
              maxWidth: "70%",
              maxHeight: "40vh",
              height: "auto",
              display: "block",
              objectFit: "contain",
              marginBottom: "1.5rem"
            }}
          />
          
          {/* Close Button */}
          <Button
            onClick={handleClose}
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              color: "#fff",
              fontWeight: "bold",
              padding: "0.5rem 1.5rem",
              cursor: "pointer",
              transition: "background-color 0.2s, color 0.2s"
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#dc3545";
              e.target.style.color = "white";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "#fff";
            }}
          >
          < FaTimes /> Close
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ErrorPage;
